import { Injectable } from '@angular/core';
import { CryptoEncService } from '../crypto-enc.service';

@Injectable()
export class CostCenterStorageService {

  dbName: string = 'tya_operation_cache';
  storeName: string = 'kv';
  costCentersKey: string = 'costcenters';

  costCentersCache: any[] = [];
  isCacheLoaded: boolean = false;
  db: any = null;

  constructor(private cryptoEncService: CryptoEncService) { }

  getCostCenters() {
    return this.costCentersCache ? this.costCentersCache : [];
  }

  loadCostCenters() {
    if (this.isCacheLoaded) {
      return Promise.resolve();
    }

    let self = this;
    return this.openDb().then(function () {
      return self.readRecord(self.costCentersKey);
    }).then(function (record) {
      self.applyRecord(record);

      if (!self.costCentersCache.length) {
        let oldValue = localStorage.getItem(self.costCentersKey);
        if (oldValue) {
          let decrypted = self.decryptValue(oldValue);
          let migrated = self.parseArray(decrypted);
          if (migrated.length) {
            self.costCentersCache = migrated;
            self.saveRecord(self.costCentersKey, self.encryptValue(JSON.stringify(self.costCentersCache)));
            localStorage.removeItem(self.costCentersKey);
          }
        }
      }

      self.isCacheLoaded = true;
    }).catch(function () {
      self.costCentersCache = [];
      self.isCacheLoaded = true;
    });
  }

  setCostCenters(costCenters) {
    this.costCentersCache = costCenters ? costCenters : [];
    this.isCacheLoaded = true;
    localStorage.removeItem(this.costCentersKey);

    let self = this;
    let encrypted = this.encryptValue(JSON.stringify(this.costCentersCache));
    this.openDb().then(function () {
      self.saveRecord(self.costCentersKey, encrypted);
    }).catch(function () { });
  }

  clearCostCenters() {
    this.costCentersCache = [];
    this.isCacheLoaded = true;
    localStorage.removeItem(this.costCentersKey);

    let self = this;
    return this.openDb().then(function () {
      return self.deleteRecord(self.costCentersKey);
    }).catch(function () { });
  }

  openDb() {
    let self = this;
    if (this.db) {
      return Promise.resolve(this.db);
    }

    return new Promise(function (resolve, reject) {
      try {
        let request = indexedDB.open(self.dbName, 1);
        request.onupgradeneeded = function () {
          let database = request.result;
          if (!database.objectStoreNames.contains(self.storeName)) {
            database.createObjectStore(self.storeName, { keyPath: 'k' });
          }
        };
        request.onsuccess = function () {
          self.db = request.result;
          resolve(self.db);
        };
        request.onerror = function () {
          reject(request.error);
        };
      } catch (e) {
        reject(e);
      }
    });
  }

  readRecord(key) {
    let self = this;
    return new Promise(function (resolve, reject) {
      try {
        let tx = self.db.transaction(self.storeName, 'readonly');
        let store = tx.objectStore(self.storeName);
        let request = store.get(key);
        request.onsuccess = function () {
          let result = request.result;
          resolve(result && result.v != undefined ? result.v : null);
        };
        request.onerror = function () {
          reject(request.error);
        };
      } catch (e) {
        reject(e);
      }
    });
  }

  saveRecord(key, value) {
    let self = this;
    return new Promise(function (resolve, reject) {
      try {
        let tx = self.db.transaction(self.storeName, 'readwrite');
        let store = tx.objectStore(self.storeName);
        store.put({ k: key, v: value });
        tx.oncomplete = function () {
          resolve(null);
        };
        tx.onerror = function () {
          reject(tx.error);
        };
      } catch (e) {
        reject(e);
      }
    });
  }

  deleteRecord(key) {
    let self = this;
    return new Promise(function (resolve, reject) {
      try {
        let tx = self.db.transaction(self.storeName, 'readwrite');
        let store = tx.objectStore(self.storeName);
        store.delete(key);
        tx.oncomplete = function () {
          resolve(null);
        };
        tx.onerror = function () {
          reject(tx.error);
        };
      } catch (e) {
        reject(e);
      }
    });
  }

  applyRecord(record) {
    if (Array.isArray(record)) {
      this.costCentersCache = record;
      return;
    }
    if (typeof record === 'string' && record) {
      let decrypted = this.decryptValue(record);
      this.costCentersCache = this.parseArray(decrypted);
      return;
    }
    this.costCentersCache = [];
  }

  parseArray(value) {
    if (!value) {
      return [];
    }
    try {
      let parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  encryptValue(value) {
    try {
      if (localStorage.getItem('is_enc_on') == 'rL1SUvvPuiEUY30i7mxdOg==') {
        return this.cryptoEncService.encrypt(value);
      }
    } catch (e) { }
    return value;
  }

  decryptValue(value) {
    try {
      if (localStorage.getItem('is_enc_on') == 'rL1SUvvPuiEUY30i7mxdOg==') {
        let dec = this.cryptoEncService.decrypt(value);
        return dec ? dec : '';
      }
    } catch (e) { }
    return value;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2607514992/src/src/app/shared/services/storage/cost-center-storage.service.ts